export const getSelectedWalletType = (store) => {
  if (!store || !store.getters) return null;
  return store.getters.selectedUserType || null;
};

export const withWalletTypeParams = (store, params = {}) => {
  const walletType = getSelectedWalletType(store);
  if (!walletType) return params;
  return { ...params, wallet_type: walletType };
};

export const withWalletTypeData = (store, data = {}) => {
  const walletType = getSelectedWalletType(store);
  if (!walletType) return data;
  return { ...data, wallet_type: walletType };
};
